export const manifest = {
  screens: {
    scr_lhr4wi: { name: "Home", route: "/" },
  },
}
